import React, {useEffect, useState} from "react";
import {apiConfig} from "../../../../config";
import axios from "axios";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";
import {ClipLoader} from "react-spinners";

export const CallsStatComp = (props: any) => {
  const [responseCallsStat, setResponseCallsStat]: [any, any] = useState(null)
  const [page, setPage] = useState(0)
  const [maxPage, setMaxPage] = useState(0)
  const [selectOperator, setSelectOperator]: [any, any] = useState(null)
  const [selectCallId, setSelectCallId]: [any, any] = useState(null)
  const [selectOperatorsAll, setSelectOperatorsAll]: [any, any] = useState([])
  const [selectProject, setSelectProject]: [any, any] = useState(null)
  const [selectProjectsAll, setSelectProjectsAll]: [any, any] = useState([])
  const [selectPhoneFilter, setPhoneFilter]: [any, any] = useState([])
  const [selectLeadStatusFilter, setLeadStatusFilter]: [any, any] = useState('')
  const [startDate, setStartDate]: [any, any] = useState(new Date().setHours(0, 0));
  const [endDate, setEndDate]: [any, any] = useState(new Date());
  const [callDuration, setCallDuration]: [any, any] = useState(null);

  const [loading, setLoading] = useState(false)


  const getUsers = async () => {
    const config = {
      method: 'get',
      url: `${apiConfig.url}/auth/list`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token_caltatToki')}`
      }
    };
    try {
      return await axios(config);
    } catch (error) {
      return {
        data: []
      }
      console.error('error', error);
    }
  }
  const getProjects = async () => {
    setLoading(true)
    const config = {
      method: 'get',
      url: `${apiConfig.url}/project/list`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token_caltatToki')}`
      }
    };
    try {
      return await axios(config);
    } catch (error) {
      console.error('error', error);
      return {
        data: []
      }
    }
  }

  const getCallsStat = async () => {
    setLoading(true)
    let tzoffset = (new Date()).getTimezoneOffset() * 60000;

    let startDateNormal = startDate ? (new Date(startDate - tzoffset)).toISOString() : null
    let endDateNormal = endDate ? (new Date(endDate - tzoffset)).toISOString() : null

    console.log(startDateNormal, endDateNormal)
    console.log(selectPhoneFilter)

    const config = {
      method: 'get',
      url: `${apiConfig.url}/statistic/calls`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token_caltatToki')}`
      },
      params: {
        size: 100,
        page: page,
        phone: selectPhoneFilter,
        call_id: selectCallId,
        lead_status: selectLeadStatusFilter,
        user_id: selectOperator ? selectOperator.value : null,
        project_id: selectProject ? selectProject.value : null,
        datetime_from: startDateNormal,
        datetime_to: endDateNormal,
        call_duration: callDuration,
      }
    };
    try {
      const response = await axios(config);
      setResponseCallsStat(response.data.calls)

      let response_users= await getUsers()
      let operatorsOptions = [
        {value: null, label: "Без оператора"}
      ]

      for (let i = 0; i < response_users.data.length; i++) {
        operatorsOptions.push(
          {value: response_users.data[i].id, label: response_users.data[i].name}
        )
      }
      setSelectOperatorsAll(operatorsOptions)

      let response_projects = await getProjects()
      let projectsOptions = [
        {value: null, label: "Без проекта"}
      ]

      for (let i = 0; i < response_projects.data.length; i++) {
        projectsOptions.push(
          {value: response_projects.data[i].id, label: response_projects.data[i].name}
        )
      }
      setSelectProjectsAll(projectsOptions)

      setLoading(false)
      setMaxPage(response.data.pages)
    } catch (error) {
      console.error('error', error);
    }
  }

  let stats = [
    <tr style={{borderBottomWidth: 1}}>
      <th>id</th>
      <th>phone</th>
      <th>status</th>
      <th>lead_status</th>
      <th>dialing_duration</th>
      <th>project</th>
      <th>user</th>
      <th>date</th>
      <th>audio_file</th>
    </tr>
  ]
  if (responseCallsStat) {
    for(let i=0; i<responseCallsStat.length; i++) {
      let callDate = new Date(Date.parse(responseCallsStat[i].created_at))
      stats.push(
        <tr key={i} style={{borderBottomWidth: 1}}>
          <td style={{textAlign: "center"}}>
            {responseCallsStat[i].id}
          </td>
          <td style={{textAlign: "center"}}>
            {responseCallsStat[i].phone}
          </td>
          <td style={{textAlign: "center"}}>
            {responseCallsStat[i].status}
          </td>
          <td style={{textAlign: "center"}}>
            {responseCallsStat[i].lead_status}
          </td>
          <td style={{textAlign: "center"}}>
            {responseCallsStat[i].dialing_duration}
          </td>
          <td style={{textAlign: "center"}}>
            {responseCallsStat[i].project?.name}
          </td>
          <td style={{textAlign: "center"}}>
            {responseCallsStat[i].user?.name}
          </td>
          <td style={{textAlign: "center"}}>
            {callDate.toLocaleString("ru")}
          </td>
          <td style={{display: "flex", justifyContent: "center"}}>
            {responseCallsStat[i].audio_file ?
              <audio style={{height: 20}} controls src={responseCallsStat[i].audio_file}/> : "Нет записи"}
          </td>
        </tr>
      )
    }
  }

  useEffect(() => {
    getCallsStat()
  }, [page])

  return (
    <div style={{display: "flex", flexDirection: "row", paddingLeft: 20}}>
      <div style={{display: "flex", marginRight: 20, width: 200, flexDirection: "column"}}>
        <div style={{display: "flex", flexDirection: "column"}}>
          <div style={{fontSize: 18, marginBottom: 20}}>
            Фильтры
          </div>
          <div>
            <div>
              Телефон
            </div>
            <input style={{width: "100%", borderWidth: 1}} onChange={(item) => {
              setPhoneFilter(item.target.value)
            }}/>
          </div>
          <div>
            <div>
              Статус звонка
            </div>
            <input style={{width: "100%", borderWidth: 1}} onChange={(item) => {
              setLeadStatusFilter(item.target.value)
            }}/>
          </div>
          <div>
            <div>
              Длительность звонка
            </div>
            <input type={'number'} style={{width: "100%", borderWidth: 1}} onChange={(item) => {
              setCallDuration(item.target.value === '' ? null : item.target.value)
            }}/>
          </div>
          <div>
            <div>
              Проект
            </div>
            <Select
              onChange={(item) => {
                setSelectProject(item)
              }}
              options={selectProjectsAll}
            />
          </div>
          <div>
            <div>
              Оператор
            </div>
            <Select
              onChange={(item) => {
                setSelectOperator(item)
              }}
              options={selectOperatorsAll}
            />
          </div>
          <div>
            <div>
              CALL ID
            </div>
            <input style={{width: "100%", borderWidth: 1}} onChange={(item) => {
              setSelectCallId(item.target.value)
            }}/>
          </div>
          <div style={{display: "flex", flex: 1, flexDirection: "column"}}>
            <div>
              Дата от
            </div>

            <div style={{display: "flex", flex: 1}}>
              <DateTimePicker
                onChange={(date: any) => {
                  date ? setStartDate(new Date(date)) : setStartDate(null)
                }}
                value={startDate}
                disableClock={true}
              />
            </div>
            <div>
              Дата до
            </div>
            <div style={{display: "flex", flex: 1}}>
              <DateTimePicker
                onChange={(date: any) => {
                  date ? setEndDate(new Date(date)) : setEndDate(null)
                }}
                value={endDate}
                disableClock={true}
              />
            </div>
          </div>
        </div>
        <button
          onClick={() => {
            page !== 0 ? setPage(0) : getCallsStat()
          }}
          style={{
            display: "flex",
            height: 50,
            justifyContent: "center",
            alignItems: 'center',
            borderWidth: 1,
            borderColor: "black",
            marginTop: 20
          }}>
          Применить фильтр
        </button>
      </div>
      <div style={{position: 'relative', display: "flex", flex: 1, height: 'calc(100vh - 110px)', flexDirection: "column", borderLeftWidth: 1}}>
        <div style={{display: "flex", flex: 1, flexDirection: "column", overflow: "auto"}}>
          <table style={{}}>
            {stats}
          </table>
        </div>
        <div style={{display: "flex", height: 50, alignItems: "center", justifyContent: "center", borderTopWidth: 1, borderColor: "black"}}>
          <button
            onClick={() => {
              if (page > 0) {
                setPage(page - 1)
              }
            }}
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "center"
            }}>
            Предыдущая
          </button>
          <div style={{display: "flex", flex: 1, justifyContent: "center"}}>
            {page+1}/{maxPage}
          </div>
          <button
            onClick={() => {
              if (maxPage > page+1) {
                setPage(page + 1)
              }
            }}
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "center"
            }}>
            Следующая
          </button>
        </div>
        {loading &&
            <div style={{
              fontSize: 30,
              position: "absolute",
              width: "100%",
              height: "100%",
              // backgroundColor: "rgba(100, 100, 100, 0.2)",
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: 'center',
            }}>
                <ClipLoader size={150} color={"black"}/>
            </div>
        }
      </div>
    </div>
  )
}
